import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { translate } from 'react-admin';
import { stringify } from 'query-string';
import PasswordIcon from '@material-ui/icons/LockOpen';



const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToPassword = ({ classes, record }) => (
        <Button
            size="small"
            color="primary"
            component={Link}
            to={{
                pathname: './passwords/' + record.id,
                data: record,
            }}
            className={classes.link}
        >
            <PasswordIcon className={classes.icon} />
        </Button>
    );


export default withStyles(styles)(LinkToPassword);